<template>
    <div>
        <PageSpinner :onloader="onloader" />
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <router-link to="/dashboard" class="text-white">
                Dashboard
            </router-link>
            <router-link to="/school/timetable-management" class="text-white">
                <i class="fa fa-ellipsis-v px-2"></i>Timetable Management
            </router-link>
            <span class="text-white"><i class="fa fa-ellipsis-v px-2"></i>TimeTable
            </span>
        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--7">
            <card header-classes="bg-transparent">
                <div>
                    <modal :show.sync="modals.TimeTableModal" modal-classes="modal-dialog-centered modal-md">
                        <div class="card bg-secondary border-0 mb-0">
                            <div class="card-body">
                                <PageSpinner :onloader="onloader" />
                                <div class="form-horizontal">
                                    <form role="form">
                                        <div class="card">
                                            <h5 class="card-header">Time Table Setup</h5>
                                            <div class="card-body">
                                                <div class="form-group">
                                                    <label>Name</label>
                                                    <input v-model="TimeTableNameVal" class="form-control"
                                                        placeholder="Enter Name" />
                                                </div>
                                                <div class="form-group">
                                                    <label>Description </label>
                                                    <input v-model="TimeTableDescriptionVal" class="form-control"
                                                        placeholder="Enter Description" />
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <template slot="footer">
                            <base-button type="default" @click="modals.TimeTableModal = false">Cancel
                            </base-button>
                            <base-button type="success" @click.prevent="SubmitData()">Submit
                            </base-button>
                        </template>
                    </modal>
                    <div class="card">
                        <div class="card-body">
                            <div
                                class="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4">
                                <h3 class="mb-3 mb-md-0">
                                    <i class="fa fa-calendar-alt"></i> Timetables
                                </h3>
                                <button type="button" @click.prevent="OpenTimeTable" class="btn btn-primary">
                                    <i class="fa fa-plus"></i> Add New Timetable
                                </button>
                            </div>
                            <div class="row mb-4">
                                <div class="col-md-6 ml-auto">
                                    <base-input class="input-group-alternative" placeholder="Search timetables..."
                                        addon-left-icon="fa fa-search" v-model="searchval">
                                    </base-input>
                                </div>
                            </div>
                            <list-skeleton v-if="!loading" :rows="3" />
                            <div v-else>
                                <div v-if="!searchedResultQuery || searchedResultQuery.length === 0"
                                    class="text-center py-5">
                                    <img src="/img/brand/empty.png" class="img-fluid mb-3" style="max-width:120px" />
                                    <!-- <p class="text-muted">{{ TimeTables && TimeTables.length === 0 ? 'No Timetables
                                        Found.' : 'No timetables match your search.' }}</p> -->
                                </div>
                                <div v-else class="row">
                                    <div class="col-lg-6" v-for="item in searchedResultQuery" :key="item.timeTableId">
                                        <div class="card m-2 animate__animated animate__backInUp">
                                            <div class="card-body bg-gradient-info">
                                                <div class="d-flex justify-content-between align-items-start mb-3">
                                                    <div>
                                                        <h5 class="card-title text-white mb-1">{{ item.timeTableName }}
                                                        </h5>
                                                        <p class="text-white small mb-0">{{ item.timeTableDescription }}
                                                        </p>
                                                    </div>
                                                    <span class="badge badge-light">
                                                        <i class="fa fa-calendar"></i>
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="card-footer bg-white">
                                                <div class="d-flex flex-column flex-sm-row justify-content-end gap-2">
                                                    <button class="btn btn-outline-secondary btn-sm"
                                                        @click="editTimeTable(item)">
                                                        <i class="fa fa-edit"></i> Edit
                                                    </button>
                                                    <button class="btn btn-info btn-sm"
                                                        @click="ViewTimeTable(item.timeTableId)">
                                                        <i class="fa fa-eye"></i> View Details
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </card>
        </div>
    </div>
</template>

<script>
import Alert from "@/mixins/Alert.mixins"
import PageSpinner from "@/components/PageSpinner"
import CheckStaffUser from "@/mixins/CheckStaffUser.mixin"
export default {
    name: "TimeTable",
    components: {
        PageSpinner
    },
    mixins: [CheckStaffUser, Alert],
    data() {
        return {
            accessDetails: null,
            TimeTableIdVal: 0,
            TimeTableNameVal: "",
            TimeTableDescriptionVal: "",
            TimeTables: null,
            searchval: "",
            onloader: "none",
            loading: false,
            IsModified: false,
            modals: {
                TimeTableModal: false
            }
        };
    },
    computed: {
        searchedResultQuery() {
            if (!this.TimeTables) return [];
            if (this.searchval) {
                const tokens = this.searchval.toLowerCase().split(" ").filter(Boolean);
                return this.TimeTables.filter((item) => {
                    return tokens.every((v) =>
                        (item.timeTableName && item.timeTableName.toLowerCase().includes(v)) ||
                        (item.timeTableDescription && item.timeTableDescription.toLowerCase().includes(v))
                    );
                });
            }
            return this.TimeTables;
        },
    },
    methods: {
        OpenTimeTable() {
            this.TimeTableNameVal = "";
            this.TimeTableDescriptionVal = "";
            this.TimeTableIdVal = 0;
            this.isModified = false;
            this.modals.TimeTableModal = true;
        },
        editTimeTable(item) {
            this.IsModified = true;
            this.TimeTableIdVal = item.timeTableId;
            this.TimeTableNameVal = item.timeTableName;
            this.TimeTableDescriptionVal = item.timeTableDescription;
            this.modals.TimeTableModal = true;
        },
        SubmitData() {
            let TimeTableName = this.TimeTableNameVal;
            let TimeTableDescription = this.TimeTableDescriptionVal;
            let TimeTableId = this.TimeTableIdVal;
            this.onloader = "flex";
            let userdata = {};
            let operationVal = "";
            if (this.isModified == false) {
                userdata = {
                    TimeTableName,
                    TimeTableDescription
                }
                operationVal = "TimeTable/CreateTimeTable";
            } else {
                userdata = {
                    TimeTableName,
                    TimeTableDescription,
                    TimeTableId
                }
                operationVal = "TimeTable/UpdateTimeTable";
            }
            this.$store
                .dispatch(operationVal, userdata)
                .then((resp) => {
                    if (resp.responseCode == "00") {
                        this.GetTimeTables();
                        this.modals.TimeTableModal = false;
                        this.isModified = false;
                        this.TimeTableIdVal = 0;
                        this.TimeTableNameVal = "";
                        this.TimeTableDescriptionVal = "";
                        this.ShowAlertSuccess('Submitted Successfully', '');
                    } else {
                        this.ShowAlertError(resp.responseMessage, '');
                    }

                })
                .catch((err) => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        GetTimeTables() {
            this.onloader = "flex";
            this.loading = false;
            this.$store
                .dispatch("TimeTable/GetTimeTables")
                .then((resp) => {
                    if (resp.responseCode == "00") {
                        this.TimeTables = resp.data;
                    }
                    this.onloader = "none";
                    this.loading = true;
                })
                .catch((err) => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        ViewTimeTable(timeTableId) {
            localStorage.setItem("TimeTableId", timeTableId);
            this.$router.push("/school/timetable-management/timetable-view");
        },
    },
    mounted() {
        this.GetTimeTables();
    },
};
</script>

<style scoped>
.bg-gradient-info {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.text-white-80 {
    color: rgba(255, 255, 255, 0.8);
}

.gap-2 {
    gap: 0.5rem;
}

.card {
    border: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s, box-shadow 0.2s;
}

.card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.card-footer {
    border-top: 1px solid #e3e6f0;
}
</style>
